import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getAbout, getSite } from '../tools/fetcher';

export default function About({ className }) {
    const [abouts, setAbouts] = useState([]);
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        getAbout().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    title: d?.title?.rendered,
                    description: d?.about_details?.description,
                }));
                setAbouts(dt);
            }
        });
    }, []);

    return (
        <div className={classNames('gap-10 grid grid-cols-1 lg:gap-[100px] lg:grid-cols-3', className)}>
            <div className={'flex flex-col gap-2 justify-center sm:gap-4'}>
                <p
                    className={
                        'font-bold leading-[32px] text-[32px] text-primary-black-100 sm:leading-[52px] sm:text-[40px]'
                    }
                >
                    {data?.about?.title}
                </p>
                <p className={'text-base text-primary-gray-101'}>{data?.about?.description}</p>
            </div>
            <div
                className={
                    'gap-6 grid grid-cols-1 sm:col-span-2 sm:gap-10 sm:grid-cols-2'
                }
            >
                {abouts.map((about, index) => (
                    <div key={index} className={'bg-primary-white-101 p-6 rounded-xl sm:p-8'}>
                        <div className={'flex justify-start text-white'}>
                            <div className={'bg-gradient-to-b from-primary-blue-102 to-primary-blue-101 flex items-center justify-center rounded-full h-10 w-10 sm:h-[60px] sm:w-[60px]'}>
                                <span className={'font-poppins font-bold sm:leading-8 sm:text-[24px]'}>{index + 1}</span>
                            </div>
                        </div>
                        <p
                            className={
                                'font-bold leading-8 text-xl text-primary-black-100 mt-6'
                            }
                        >
                            {about.title.replace(/&#038;/g , "&")}
                        </p>
                        <p
                            className={
                                'mt-2 text-sm text-primary-gray-101 sm:leading-7 sm:text-base'
                            }
                        >
                            {about.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
